import { render, staticRenderFns } from "./CategoryBraindatesItem.vue?vue&type=template&id=736850fd&scoped=true&"
import script from "./CategoryBraindatesItem.vue?vue&type=script&lang=js&"
export * from "./CategoryBraindatesItem.vue?vue&type=script&lang=js&"
import style0 from "./CategoryBraindatesItem.vue?vue&type=style&index=0&id=736850fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736850fd",
  null
  
)

/* custom blocks */
import block0 from "./CategoryBraindatesItem.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports